"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangelogRecorder = void 0;
var core_1 = require("@athena-portal/core");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var ChangelogRecorder = exports.ChangelogRecorder = /** @class */ (function () {
    function ChangelogRecorder() {
    }
    ChangelogRecorder.prototype.recordQuestion = function (event, context) {
        this.recordInteraction(context.engine.getInteraction(), event, context.question.interactionField, context.page && context.page.pageId);
    };
    ChangelogRecorder.prototype.recordPage = function (event, context, field) {
        this.recordInteraction(context.engine.getInteraction(), event, field, context.page && context.page.pageId);
    };
    ChangelogRecorder.prototype.record = function (interaction, event, field, page) {
        this.recordInteraction(interaction, event, field, page);
    };
    ChangelogRecorder.prototype.recordInteraction = function (interaction, event, field, page, timeout) {
        var _this = this;
        if (!this.canRecord(interaction)) {
            return;
        }
        var timeoutProperty = "FalconCommandsExecutorChangelog_".concat(field || page);
        window[timeoutProperty] && clearTimeout(window[timeoutProperty]);
        window[timeoutProperty] = setTimeout(function () {
            _this.journeyRuntimeService.doBackendAction("changelog", interaction, {
                'cdcEvent': event,
                'cdcField': field,
                'cdcPage': page,
            }, false).subscribe();
        }, timeout || 2000);
    };
    ChangelogRecorder.prototype.canRecord = function (interaction) {
        if (!interaction._id) {
            return false;
        }
        return true;
    };
    __decorate([
        (0, core_1.lazyInject)(plugin_journey_1.Types.JourneyRuntimeService),
        __metadata("design:type", Object)
    ], ChangelogRecorder.prototype, "journeyRuntimeService", void 0);
    ChangelogRecorder = __decorate([
        (0, core_1.injectable)()
    ], ChangelogRecorder);
    return ChangelogRecorder;
}());
//# sourceMappingURL=ChangelogRecorder.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/services/ChangelogRecorder.js
// module id = 3262
// module chunks = 0